<script>
import baseMixin from '@mixins/baseMixin'
import { mapActions, mapGetters } from 'vuex'
import { orderBy } from 'lodash'
export default {
  name: 'TheClientSelectorList',
  mixins: [baseMixin],
  props: {
    search: {
      type: String,
      default: '',
    },
  },
  data: () => {
    return {}
  },
  computed: {
    ...mapGetters({
      permissions: 'auth/permissions',
      clientDetails: 'client/clientDetails',
      selectedClientId: 'client/selectedClientId',
    }),
    filteredItems() {
      const filteredList = []
      for (const group of this.permissions) {
        const clients = group.clients.filter((x) =>
          x.clientName.toLowerCase().includes(this.search.toLowerCase())
        )
        if (clients.length > 0) {
          filteredList.push({
            groupId: group.groupId,
            groupName: group.groupName,
            clients: orderBy(clients, 'clientName', 'asc'),
          })
        }
      }
      return filteredList
    },
    isCurrentlyOnOverviewPage() {
      const clientOverviewPages = [
        this.routeDefinitions.clientOverview.name,
        this.routeDefinitions.clientGroupOverview.name,
      ]
      return clientOverviewPages.includes(this.$route.name)
    },
  },
  methods: {
    ...mapActions({
      setClient: 'client/setClient',
    }),
    hasGroup(group) {
      return group.groupId !== -1
    },
    async switchClient(clientId) {
      // If client is already selected, no action and not on the overview page
      if (
        this.clientDetails !== null &&
        this.clientDetails.id === clientId &&
        !this.isCurrentlyOnOverviewPage
      )
        return
      const result = await this.setClient(clientId)
      if (result.isSuccess) {
        this.$router.push({ name: 'home', query: { cid: clientId } })
      }
    },
  },
}
</script>

<template>
  <v-list
    style="max-height: 300px; overflow-y: auto;"
    two-line
    class="transparent py-0 my-0"
  >
    <template v-for="group in filteredItems">
      <v-subheader
        v-if="hasGroup(group)"
        :key="`the-client-selector-list_group-title_${group.groupId}`"
        class="caption client-selector-group-title"
      >
        {{ group.groupName }}
      </v-subheader>
      <template v-for="client in group.clients">
        <v-list-item
          :key="`the-client-selector-list_client_${client.clientId}`"
          color="blue"
          :input-value="selectedClientId === client.clientId"
          class="client-selector-list-item"
          @click="switchClient(client.clientId)"
        >
          <v-list-item-content
            :class="hasGroup(group) ? 'ml-4' : ''"
            class="pb-2"
          >
            <v-list-item-title :title="client.clientName" class="body-2">
              {{ client.clientName }}
            </v-list-item-title>
            <v-list-item-subtitle class="caption mb-2">
              <span
                v-for="(location, index) in client.locations"
                :key="
                  `the-client-selector-list_location_${location.locationId}`
                "
              >
                <p v-if="index < 5" class="my-0">{{
                  `${location.locationName}`
                }}</p>
                <p v-else-if="index === 5" class="my-0">{{
                  `+ ${client.locations.length - index} more`
                }}</p>
              </span>
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action
            v-if="selectedClientId === client.clientId"
            title="Currently selected"
          >
            <v-icon x-small>mdi-account</v-icon>
          </v-list-item-action>
        </v-list-item>
      </template>
      <v-divider
        :key="`client-selector-group-divider-${group.groupId}`"
      ></v-divider>
    </template>
  </v-list>
</template>
